const AllMedia = () => {
  return (
    <div>
      <h4>All Media</h4>
      <hr />
      <p>list of all media to edit </p>
    </div>
  );
}

export default AllMedia
